import shippingMethodsSaga from './shipping-methods.saga';

export default shippingMethodsSaga;
